import { defineMessages } from 'react-intl'

export default defineMessages({
  small: {
    id: 'containers.EmbeddedCompanyPage.small',
    defaultMessage: 'Small',
  },
  medium: {
    id: 'containers.EmbeddedCompanyPage.medium',
    defaultMessage: 'Medium',
  },
  large: {
    id: 'containers.EmbeddedCompanyPage.large',
    defaultMessage: 'Large',
  },
  key: {
    id: 'containers.EmbeddedCompanyPage.key',
    defaultMessage: 'Key',
  },
  synchronize: {
    id: 'containers.EmbeddedCompanyPage.synchronize',
    defaultMessage: 'Synchronize company',
  },
  company: {
    id: 'containers.EmbeddedCompanyPage.company',
    defaultMessage: 'Company',
  },
  synchronizing: {
    id: 'containers.EmbeddedCompanyPage.synchronizing',
    defaultMessage: 'Syncronizing company..',
  },
  openInAme: {
    id: 'containers.EmbeddedCompanyPage.openInAme',
    defaultMessage: 'Open in AME',
  },
  saving: {
    id: 'containers.EmbeddedCompanyPage.saving',
    defaultMessage: 'Saving..',
  },
  save: {
    id: 'containers.EmbeddedCompanyPage.save',
    defaultMessage: 'Save',
  },
  classification: {
    id: 'containers.EmbeddedCompanyPage.classification',
    defaultMessage: 'Classification',
  },
  subscribe: {
    id: 'containers.EmbeddedCompanyPage.subscribe',
    defaultMessage: 'Subscribe to newsletter',
  },
  requirePurchase: {
    id: 'containers.EmbeddedCompanyPage.requirePurchase',
    defaultMessage: 'Require purchase order (PO)',
  },
  deliveryResponsible: {
    id: 'containers.EmbeddedCompanyPage.deliveryResponsible',
    defaultMessage: 'Delivery Responsible',
  },
  contact: {
    id: 'containers.EmbeddedCompanyPage.contact',
    defaultMessage: 'Producer',
  },
  companyContact: {
    id: 'containers.EmbeddedCompanyPage.companyContact',
    defaultMessage: 'Company Contact',
  },
  usageExpirationReminder: {
    id: 'containers.EmbeddedCompanyPage.usageExpirationReminder',
    defaultMessage: 'Send usage expiration reminder emails',
  },
})
